import { Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import { LoadingOutlined } from '@ant-design/icons';

const RoundedButton = observer(
    ({
        icon: Icon,
        disabled,
        className,
        onClick,
        isLoading,
        isActive,
        onDoubleClick,
    }) => {
        return (
            <button
                onDoubleClick={onDoubleClick}
                disabled={disabled}
                className={`rounded-full w-[32px] h-[32px] flex justify-center items-center rounded-btn cursor-pointer ${isActive ? 'active-rounded-btn' : ''} ${className} `}
                onClick={onClick}>
                {isLoading ? (
                    <Spin
                        indicator={
                            <LoadingOutlined
                                spin
                                style={{ color: 'black', fontSize: 24 }}
                            />
                        }
                        size="large"
                    />
                ) : (
                    Icon
                )}
            </button>
        );
    },
);

export default RoundedButton;
